const tdk = {
  title: {
    zh_CN: "币王Biking 官网-多元化游戏与数字货币交易平台",
    zh_TW: "幣王Biking 官網-多元化遊戲與數位貨幣交易平台",
    en_US: "Biking Exchange -Diversified Game and Digital Currency Trading Platform",
    ko_KR: "Biking Exchange -Diversified Game and Digital Currency Trading Platform",
    pt_BR: "Biking Exchange -Diversified Game and Digital Currency Trading Platform",
    ja_JP: "Biking Exchange -Diversified Game and Digital Currency Trading Platform",
    vi_VN: "Biking Exchange official website - Diversified gaming and cryptocurrency trading platform.",
    id_ID: "Biking Exchange official website - Diversified gaming and cryptocurrency trading platform.",
    tr_TR: "Biking Exchange -Diversified Game and Digital Currency Trading Platform",
    ru_Ru: "Biking Exchange -Diversified Game and Digital Currency Trading Platform",
    fr_FR: "Biking Exchange -Diversified Game and Digital Currency Trading Platform",
  },
  description: {
    zh_CN:
      "币王BiKing Exchange是全球领先的加密货币交易平台之一。 支持购买、出售和持有USDT、BTC、ETH等数字货币",
    zh_TW:
      "幣王BiKing Exchange是全球領先的加密貨幣交易平台之一。 支持購買、出售和持有USDT、BTC、ETH等數位貨幣",
    en_US:
      "BiKing Exchange is one of the world's leading cryptocurrency trading platforms. Support buy, sell, and hold USDT, BTC, ETH and other digital currencies",
    ko_KR: "BiKing Exchange is one of the world's leading cryptocurrency trading platforms. Support buy, sell, and hold USDT, BTC, ETH and other digital currencies",
    pt_BR: "BiKing Exchange is one of the world's leading cryptocurrency trading platforms. Support buy, sell, and hold USDT, BTC, ETH and other digital currencies",
    ja_JP: "BiKing Exchange is one of the world's leading cryptocurrency trading platforms. Support buy, sell, and hold USDT, BTC, ETH and other digital currencies",
    vi_VN: "Biking Exchange is one of the world's leading cryptocurrency trading platforms. It supports buying, selling, and holding digital currencies such as USDT, BTC, ETH, and more.",
    id_ID: "Biking Exchange is one of the world's leading cryptocurrency trading platforms. It supports buying, selling, and holding digital currencies such as USDT, BTC, ETH, and more.",
    tr_TR:"BiKing Exchange is one of the world's leading cryptocurrency trading platforms. Support buy, sell, and hold USDT, BTC, ETH and other digital currencies",
    fr_FR:"BiKing Exchange is one of the world's leading cryptocurrency trading platforms. Support buy, sell, and hold USDT, BTC, ETH and other digital currencies",
      ru_Ru: "BiKing Exchange is one of the world's leading cryptocurrency trading platforms. Support buy, sell, and hold USDT, BTC, ETH and other digital currencies"
    
  },
  keywords: {
    zh_CN:
      "biking exchange,bikingex, BiKing official website,币王",
    zh_TW:
      "biking exchange,bikingex, BiKing official website,幣王",
    en_US:
      "biking exchange,bikingex, BiKing official website,biking",
    ko_KR: "biking exchange,bikingex, BiKing official website,biking",
    pt_BR: "biking exchange,bikingex, BiKing official website,biking",
    ja_JP: "biking exchange,bikingex, BiKing official website,biking",
    vi_VN: "biking exchange,bikingex, BiKing official website,biking",
    id_ID: "biking exchange,bikingex, BiKing official website,biking",
    tr_TR: "biking exchange,bikingex, BiKing official website,biking",
    ru_Ru: "biking exchange,bikingex, BiKing official website,biking",
    fr_FR: "biking exchange,bikingex, BiKing official website,biking",
  },
};



export { tdk };



// WEBPACK FOOTER //
// ./src/assets/js/TDK.js